export default {
  line: "Beralih jalur",
  language: "Pilih bahasa",
  common: [
    "layanan daring",
    "Lepaskan",
    "robot",
    "Video Otomatis",
    "Mulailah",
    "Video yang tersisa hari ini",
    "Setel jumlah video otomatis",
    "Versi premium hanya tersedia untuk anggota, silakan tingkatkan",
    "Tolong atur jumlah video otomatis"
  ],
  upload: [
    "mengunggah...",
    "format buruk",
    "Unggahan berhasil",
    "gagal mengunggah"
  ],
  appMsg: [
    "Siap untuk mengunduh pembaruan...",
    "Unduh selesai, apakah akan menginstal paket pembaruan",
    "Gagal mengunduh pembaruan",
    "Diunduh {num}%",
    "Memperbarui...",
    "Pembaruan berhasil, akan dimulai ulang",
    "Pembaharuan gagal",
    "Tekan lagi untuk keluar dari aplikasi"
  ],
  vanPull: [
    "Tidak ada data lagi",
    "tidak ada data"
  ],
  login: {
    text: [
      "Simpan kata sandi",
      "Masuk...",
      "Login Sekarang",
      "Lupa kata sandi",
      "Login Telepon",
      "Login E-mail"
    ],
    placeholder: [
      "Silakan mengisi nomor telepon",
      "Silakan mengisi kata sandi anda",
      "Silakan masukkan alamat e-mail"
    ],
    i18n: [
      "Tidak ada akun untuk {title}?",
      "daftar"
    ]
  },
  register: {
    text: [
      "Selamat mendaftar",
      "Mengirim kode SMS...",
      "Dapatkan kode SMS",
      "Mendaftar...",
      "Daftar sekarang",
      "Punya akun, unduh sekarang",
      "Registrasi Telepon",
      "Registrasi E-mail",
      "Dapatkan kode verifikasi",
      "Kode verifikasi SMS",
      "Kode verifikasi e-mail",
      "Kirim ulang kode verifikasi"
    ],
    placeholder: [
      "Silakan mengisi nomor telepon",
      "Silakan mengisi kode verifikasi SMS",
      "Silakan mengisi kata sandi Anda",
      "Silahkan konfirmasi kata sandi Anda",
      "Silakan mengisi kode undangan",
      "Kedua kata sandi itu berbeda",
      "Silakan mengisi kode verifikasi"
    ],
    i18n: [
      "Sudah memiliki akun?",
      "Gabung"
    ],
    tips: "Tutorial Pendaftaran"
  },
  footer: [
    "Beranda",
    "Video",
    "obrolan rahasia",
    "pelayanan pelanggan",
    "Milikku",
    "penghasilan",
    "Dana",
    "Dinamis",
    "Aktivitas"
  ],
  home: {
    broadcast: "Selamat kepada anggota {member} karena merekomendasikan {grade} untuk mendapatkan {currency}{reward} hadiah promosi!",
    menu: [
      "Zona VIP",
      "Video tutorial",
      "Hadiah Promosi",
      "Media Koperasi",
      "Kekuatan Perusahaan",
      "Asuransi Akun"
    ],
    taskHall: {
      title: [
        "Lobi Video",
        "Aula Penerbitan Bisnis"
      ]
    },
    memberList: {
      title: "Daftar Anggota",
      data: [
        "Selamat kepada {member}",
        "Tonton {num} kali hari ini dan dapatkan {currency}{profit}!"
      ]
    },
    businessList: {
      title: "Daftar Bisnis",
      data: [
        "{member}",
        "Memposting {num} video tunggal hari ini"
      ]
    },
    noticeTitle: "Pemberitahuan Terbaru",
    msg: "Video tidak tersedia",
    video: "Belum ada video tutorial",
    title: ["Profil Perusahaan", "Tingkat Keanggotaan"]
  },
  postTask: {
    navBar: {
      title: "Posting Video",
      right: "Aturan Penerbitan"
    },
    field: [{
        label: "Klasifikasi video",
      },
      {
        label: "Judul video",
        placeholder: "Silakan masukkan judul video",
        error: "Judul video tidak boleh kosong"
      },
      {
        label: "Perkenalan Video",
        placeholder: "Silakan masukkan pengantar video"
      },
      {
        label: "Harga satuan video",
        placeholder: "Silakan masukkan harga satuan video",
        error: "Harga satuan video tidak boleh kosong"
      },
      {
        label: "Jumlah Terima",
        placeholder: "Silakan masukkan jumlah yang akan diterima",
        error: "Jumlah yang akan diterima tidak boleh kosong"
      },
      {
        label: "Waktu pengumpulan",
        placeholder: "Silakan masukkan jumlah klaim",
        right: "waktu/orang",
        error: "Waktu pengumpulan tidak boleh kosong"
      },
      {
        label: "Total harga video",
        error: "Harga total video tidak dihitung"
      },
      {
        label: "Informasi tautan",
        placeholder: "Silakan masukkan alamat tautan",
        error: "Informasi tautan tidak boleh kosong"
      },
      {
        label: "Tingkat Video",
      },
      {
        label: "Batas Waktu",
        placeholder: "Klik untuk memilih tanggal",
        error: "Tanggal kedaluwarsa tidak boleh kosong"
      },
      {
        label: "Kondisi Lengkap",
        error: "Silakan pilih kondisi penyelesaian"
      },
      {
        label: "Permintaan Unggah",
        placeholder: "Silakan masukkan persyaratan unggah",
      },
      {
        label: "Contoh Audit",
      },
      {
        label: "Langkah Operasi",
        placeholder: "Langkah-langkah sederhana dan mudah diikuti membantu menyelesaikan!",
        error: "Langkah operasi tidak boleh kosong",
        img: "Ada diagram langkah yang tidak sempurna"
      },
    ],
    button: "Kirim",
    step: {
      title: "Langkah Operasi",
      left: "Batal",
      right: "Selesai",
      placeholder: "Silakan masukkan deskripsi langkah",
      button: [
        "menghapus",
        "Tambahkan"
      ]
    },
    tips: [
      "Biaya platform sekitar{pump}{br}Rilis ini memerlukan pembayaran sekitar{price}, pastikan saldo akun mencukupi{a}{br}Pengingat: Platform ini melarang pelepasan pornografi, perjudian, narkoba, dan politik dan Konten lainnya yang dilarang oleh hukum, jika ditemukan mengurangi poin, akun akan diblokir.",
      "untuk mengisi ulang",
      "Jaga setidaknya satu langkah",
      "Tambahkan hingga sepuluh langkah"
    ]
  },
  vip: {
    user: {
      title: [
        "level saat ini",
        "turis"
      ],
      label: "Video Harian",
      value: [
        "Masa Berlaku",
        "Permanen",
        "silahkan masuk terlebih dahulu",
        " hari",
        "Tanggal kadaluarsa"
      ],
    },
    list: {
      label: "Video <b>{number}</b> kali per hari",
      button: [
        "Aktif Sekarang",
        "Perbarui sekarang"
      ],
      text: [
        "Penghasilan Harian",
        "Pendapatan bulanan",
        "Hadiah rekomendasi: per orang",
        "Gratis",
        "sesuai pesanan"
      ]
    },
    dialog: [
      "Apakah anda yakin akan membayar {currency} {amount} untuk menjadi {name}?",
      "Anda saat ini {currname} dan tidak bisa menjadi {name}",
      "Apakah Anda yakin perlu menghabiskan {currency} {amount} untuk memperbarui {name}?"
    ],
    more: "Lihat lebih banyak",
    top: [
      "Harga untuk peningkatan",
      "Rabat Pembelian",
      ["Level 1", "Level 2", "Level 3"],
      ["Harga", "Rincian"],
      "kedaluwarsa"
    ]
  },
  user: {
    title: [
      "Video Saya",
      "Catatan Pribadi"
    ],
    default: [
      "Milikku",
      "Masuk akun",
      "Kode Undangan",
      "keluar",
      "keseimbangan",
      "emas",
      "dompet saya",
      "judul",
      "membatasi",
      "bagus",
      "bagus sekali",
      "atasan saya"
    ],
    grid: [
      "Saldo Pribadi",
      "Penghasilan Kemarin",
      "Penghasilan hari ini",
      "Penghasilan minggu ini",
      "Penghasilan bulan ini",
      "Penghasilan bulan lalu",
      "Total pendapatan",
      "Video hari ini (jumlah)",
      "Video yang tersisa hari ini (tunggal)",
      "Komisi hari ini",
      "Rebate hari ini",
      ["hari ini","kemarin","minggu ini","bulan ini"],
      ["Lihat Penghasilan", "Penghasilan Promosi", "Penghasilan Crowdfunding","Pendapatan Investasi","Rabat investasi"],
      ["Pendaftaran minggu ini", "Pendaftaran yang valid minggu ini", "Total gaji"],
      ["Hari ini", "Kemarin", "Tiga hari"]
    ],
    menu: [
      "Tonton Sejarah",
      "Ulasan Video",
      "Manajemen Rilis",
      "Informasi pribadi",
      "Pengikatan akun",
      "Pernyataan Harian",
      "Catatan Akuntansi",
      "Mengundang teman",
      "Laporan Tim",
      "Petunjuk Bantuan",
      "Pusat Kredit",
      "Unduh aplikasi",
      "Investasi Saya"
    ]
  },
  userInfo: {
    default: [
      "Informasi pribadi",
      "avatar",
      "Nomor telepon",
      "Kartu bank",
      "Alipay",
      "Diverifikasi",
      "kata sandi masuk",
      "Kata Sandi Dana",
      "Klik Pengaturan",
      "Ubah avatar",
      "Ubah kata sandi masuk",
      "Ubah Kata Sandi Dana",
      "Kirimkan",
      "Mengosongkan cache",
      "dompet USDT",
      "Tekan Saklar",
      "alamat saya"
    ],
    label: [
      "Kata sandi masuk asli",
      "Kata sandi masuk baru",
      "Konfirmasi sandi",
      "Password Dana Asli",
      "Password Dana Baru",
      "Konfirmasi sandi",
      "Lupa kata sandi dana",
      "Kode verifikasi SMS",
      "Kode verifikasi"
    ],
    placeholder: [
      "Silakan masukkan kata sandi login asli",
      "Silakan masukkan kata sandi login baru",
      "Silahkan konfirmasi password login",
      "Silakan masukkan kata sandi dana asli",
      "Silakan masukkan kata sandi dana baru",
      "Mohon konfirmasi kata sandi dana"
    ]
  },
  userSet: {
    default: [
      "Diverifikasi",
      "rincian",
      "Ikat Alipay",
      "Kirimkan",
      "Ikat dompet USDT",
      "Ubah alamat dompet",
      "Verifikasi email",
      "contoh grafik",
      ["Meninjau", "Audit Berhasil", "Audit Gagal"]
    ],
    label: [
      "nama asli",
      "nomor QQ",
      "Akun Alipay",
      "Nama Alipay",
      "Jenis Dompet",
      "Alamat dompet",
      "Alamat",
      "Kontak",
      "Telepon",
      "tangkapan layar dompet"
    ],
    placeholder: [
      "Silakan masukkan nama asli Anda (nama saya digunakan untuk penarikan)",
      "Silakan masukkan nomor QQ",
      "Silakan masukkan nomor akun Alipay",
      "Silakan masukkan nama Alipay",
      "Silakan pilih jenis dompet",
      "Silakan masukkan alamat dompet",
      "Silakan masukkan alamat rinci",
      "Silahkan verifikasi nama asli Anda terlebih dahulu",
      "Harap ikat alamat email Anda terlebih dahulu"
    ],
    tips: "Pengingat hangat: Kartu bank yang terikat tidak dapat diubah, akan digunakan untuk Anda menarik uang"
  },
  bindAccount: {
    default: [
      "Mengikat Akun",
      "Lihat Tutorial",
      "Kirimkan"
    ],
    tabs: [
      "Akun",
      "Akun",
      "Akun"
    ],
    label: [
      "Petunjuk",
      "Tambahkan tangkapan layar",
      "Akun"
    ],
    placeholder: "Silakan masukkan akun {account}"
  },
  bankCard: {
    default: [
      "Ikat kartu bank",
      "Verifikasi sekarang",
      "Menyerahkan...",
      "Tambahkan sekarang",
      "Tambahkan"
    ],
    tips: [
      "Harap tambahkan kartu bank setelah verifikasi nama asli",
      "Nama akun yang Anda ikat dengan kartu bank Anda harus sama dengan nama asli Anda yang telah diverifikasi, jika tidak, Anda tidak akan berhasil menarik uang tunai."
    ],
    label: [
      "Nama",
      "Nama bank",
      "Akun bank",
      "Kode IFSC"
    ],
    placeholder: [
      "Silakan pilih nama bank",
      "Silakan masukkan rekening bank",
      "Silakan masukkan kode IFSC"
    ]
  },
  wallet: {
    default: [
      "dompet saya",
      "Isi ulang",
      "Penarikan",
      "Rekor isi ulang",
      "Catatan penarikan",
      "Mengenakan biaya",
      "membawa",
      "Alipay"
    ],
    label: [
      "Metode Penarikan",
      "Jumlah penarikan",
      "Kata Sandi Dana",
      "Kirimkan",
      "Nomor telepon",
      "Surat",
      "IFSC"
    ],
    placeholder: [
      "Pilih metode penarikan",
      "Silakan masukkan jumlah penarikan",
      "Silakan masukkan kata sandi dana",
      "Silakan pilih metode penarikan",
      "Silakan masukkan nomor ponsel penerima",
      "Silakan masukkan alamat e-mail penerima",
      "Silakan masukkan penerima pembayaran IFSC"
    ],
    msg: [
      "Anda belum mengatur kata sandi dana, silakan atur terlebih dahulu",
      "Anda belum mengikat kartu bank Anda, silakan ikat dulu"
    ]
  },
  recharge: {
    default: [
      "Isi ulang",
      "Rincian Isi Ulang",
      "Rekor isi ulang",
      "Saldo {money} yang tersedia, silakan pilih metode isi ulang",
      "Jumlah minimum satu transaksi adalah {currency}{min}, maksimum {currency}{max}, dan biaya penanganannya adalah {fee}%",
      "menyerahkan...",
      "Isi ulang sekarang",
      "kembali",
      "Memuat..."
    ],
    label: [
      "Jumlah isi ulang",
      "Saluran Isi Ulang",
      "transfer nama",
      "Nama Pembayar",
      "Ponsel Pembayar",
      "Akun UPI Pembayar",
      "E-mail Pembayar"
    ],
    placeholder: [
      "Silakan masukkan jumlah isi ulang",
      "Silakan pilih saluran isi ulang",
      "Silakan masukkan nama transfer",
      "Satu jumlah minimum adalah {currency}{min}",
      "Jumlah maksimum satu transaksi adalah {currency}{max}",
      "Silakan masukkan nama pembayar",
      "Silakan masukkan nomor ponsel pembayar, diikuti dengan kode area internasional, seperti +86",
      "Silakan masukkan akun UPI pembayar",
      "Silakan masukkan e-mail pembayar"
    ],
    info: [
      "Jumlah isi ulang",
      "jumlah order",
      "Bank Penerima",
      "Akun pembayaran",
      "Pembayar",
      "salinan",
      "{type} transfer",
      "Transfer Tangkapan Layar",
      "Kirimkan",
      "Kode IFSC",
      "UPI",
      "petunjuk penanganan",
      "Alamat dompet",
      "Terima kode QR",
    ],
    tips: [
      "Silakan pilih metode berikut untuk mentransfer jumlah yang sesuai untuk menghindari keterlambatan cek keuangan<br>Setelah transfer, harap unggah tangkapan layar transfer sebagai bukti verifikasi",
      "Silakan pindai kode QR untuk mentransfer jumlah isi ulang Anda",
      "Silakan ikuti informasi di bawah ini untuk menyelesaikan transfer",
      "Kiat: Setelah pembayaran berhasil, silakan hubungi layanan pelanggan online dan berikan nomor akun anggota Anda, jumlah isi ulang, nomor pesanan, nomor rekening deposan, dan waktu isi ulang; akan lebih mudah bagi keuangan untuk menambahkan dana untuk Anda tepat waktu",
      "Catatan: Anggota harus mengirimkan setiap pembayaran transfer satu kali",
      "Setelah transfer silahkan upload screenshot transfer sebagai bukti verifikasi",
      "Silakan pilih metode berikut untuk mentransfer jumlah yang sesuai",
      "Silakan unggah tangkapan layar transfer",
      "Nilai tukar:{price}×{rate}={currency}<b>{money}</b>,(1USDT={currency}{rate})",
      "Isi ulang dan kembalikan"
    ]
  },
  task: {
    default: [
      "Tonton Sejarah",
      "Persyaratan Video",
      "membuat",
      "tinjauan",
      "Buka tautan",
      "Salin tautan",
      "patokan harga",
      "Kirimkan",
      "menyerah",
      "Waktu Menonton"
    ],
    tabs: [
      "pengolahan",
      "sedang ditinjau",
      "lengkap",
      "gagal",
      "jahat",
      "Ditinggalkan"
    ],
    msg: "Silahkan unggah gambar video yang sudah selesai",
    info: [
      "Rincian Video",
      "Judul video",
      "Penghasilan Video",
      "Deskripsi Video",
      "Permintaan Unggah",
      "Kirim Sampel",
      "Pengguna tidak mengirimkan sampel",
      "Petunjuk Pemeriksaan",
      "Tanggal Peninjauan",
      "sisi permintaan",
      "melepaskan",
      "salinan",
      "melompat",
      "Langkah-langkah video",
      "Langkah {index}",
      "Contoh Pemeriksaan",
      "Tidak ada sampel ulasan",
      "Memuat...",
      "buang video",
      "mulai menonton",
      "Posting Konten"
    ],
    index: [
      "identitas saat ini",
      "Level Anda saat ini adalah <i style=\"color:#1989fa\">{currVip}</i><br>Anda hanya dapat mengklaim <i style=\"color:#1989fa\">{currVip} saat ini < /i>Video level<br>Apakah akan menambahkan level <i style=\"color:#dd6161\">{vip}</i>",
      "Bergabung sekarang",
      "Silakan pilih kategori video"
    ],
    list: [
      "Daftar Video",
      "sisi permintaan",
      "Sisa",
      "Memerlukan",
      "menerima"
    ],
    show: [
      "Rincian Video",
      "Manusia telah mendapatkan",
      "{num} tempat tersisa",
      "Tinjau dalam 48 jam",
      "Deskripsi Video",
      "sisi permintaan",
      "Kriteria Pemeriksaan",
      "salinan",
      "melompat",
      "Langkah-langkah video",
      "Langkah {index}",
      "Contoh Pemeriksaan",
      "Tidak ada sampel ulasan",
      "Memuat...",
      "menyerahkan...",
      "Dapatkan video",
      "login segera",
      "Posting Konten"
    ]
  },
  audit: {
    default: [
      "Ulasan Video",
      "Pengguna Akuisisi",
      "Tanggal Koleksi",
      "Diperbarui",
      "tinjauan",
    ],
    tabs: [
      "pengolahan",
      "sedang ditinjau",
      "lengkap",
      "gagal"
    ],
    info: [
      "Rincian Pemeriksaan",
      "Judul video",
      "Jumlah Video",
      "orang selesai",
      "{num} tempat tersisa",
      "Deskripsi Video",
      "informasi tautan",
      "Contoh Pemeriksaan",
      "Pengguna Akuisisi",
      "menerima",
      "kondisi selesai",
      "Kirim Sampel",
      "Pengguna tidak mengirimkan sampel",
      "Diperbarui",
      "Memuat...",
      "jahat",
      "Percobaan Ulang",
      "gagal",
      "kesuksesan",
      "Ulasan Video",
      "Petunjuk Pemeriksaan",
      "Silakan masukkan deskripsi ulasan",
      "Video yang dikirimkan tidak memenuhi syarat dan perlu dikirim ulang untuk ditinjau",
      "Selamat atas selesainya video, teruslah berkarya",
      "Screenshot halaman video yang dikirimkan salah, video gagal",
      "Pengiriman video berbahaya, video gagal"
    ]
  },
  postRecord: [
    "Manajemen Rilis",
    "melepaskan",
    "Total",
    "lengkap",
    "tanggal habis tempo",
    "tinjauan",
    "Membuka",
    "mengedit"
  ],
  dayReport: [
    "Pernyataan Harian",
    "Total pendapatan",
    "Video saya yang sudah selesai",
    "Penghasilan Video Saya",
    "Video bawahan selesai",
    "Penghasilan Video Bawahan",
    "satu",
    "30 hari terakhir",
    "kuantitas",
    "video",
    "bawahan",
    "Konsumsi",
    "tanggal"
  ],
  fundRecord: {
    default: [
      "Catatan Biaya",
      "Rekor isi ulang",
      "Catatan pendapatan",
      "Mengenakan biaya",
      "menerima",
      "cabang"
    ],
    tabs: [
      "penghasilan",
      "pengeluaran",
      "Top up"
    ]
  },
  promote: [
    ["Setiap {num} pengguna valid yang diundang", "Dapatkan", "Uang Tunai"],
    "Bisa ditarik langsung",
    "Setiap {num} pengguna valid yang diundang",
    ["Hadiah Harian", "Semua orang dapat mengklaim setiap hari"],
    ["Pengguna yang valid","Undang {num} pengguna yang valid setiap hari"],
    ["Undang", "Terima", "Undang sekarang"],
    "Penghargaan Karyawan Tim",
    ["agen bintang", "bonus", "gaji"],
    ["orang", "permintaan", "diundang"],
    "Pengantar Komisi",
    ["Bagikan", "Dapatkan Segera"],
    ["Bagikan ke platform sosial", "Bagikan"],
    ["isi ulang", "isi ulang sendiri", "isi ulang"],
    ["Penambang", "Beli Penambang", "Beli"],
    ["manajemen keuangan", "investasi dan manajemen keuangan", "investasi"],
    ["Berbagi dengan teman segera", "Kode undangan"],
    ["Salin tautan", "Salin kode undangan", "Kode QR", "Bagikan poster"],
    "Simpan gambar",
    "Teman meningkatkan hadiah VIP",
    "detail"
  ],
  teamReport: {
    default: [
      "Cari",
      "Keseimbangan Tim",
      "Penghasilan Tim",
      "Pengisian Ulang Tim",
      "Penarikan Tim",
      "Jumlah pengisian pertama",
      "Jumlah orang yang direkomendasikan",
      "ukuran tim",
      "Tim Baru",
      "individu",
      "SAYA",
      "pengguna",
      "Isi ulang",
      "Penarikan",
      "potongan harga",
      "video",
      "Pilih tahun bulan hari",
      "Tidak ada data",
      "Jumlah isi ulang",
      "Jumlah orang yang diisi ulang",
      "Penghasilan Promosi",
      "Jumlah total VIP",
      "Jumlah orang yang efektif"
    ],
    tabs: [
      "Laporan Tim",
      "Tim ku"
    ],
    team: [
      "Level 1",
      "Level 2",
      "Level 3"
    ]
  },
  help: [
    "Petunjuk Bantuan",
    "belum ada konten"
  ],
  credit: [
    "Pusat Kredit",
    "Laporan Kredit",
    "Riwayat Kredit",
    "<p>1. Poin kredit dinilai seminggu sekali</p><p>2. Poin kredit pengguna awal: <b>60</b></p><p>3. Jika terdeteksi bahwa pengguna lakukan pengunggahan video Gambar palsu akan dipotong selama satu hari: <b>1</b> poin, batas pengurangan maksimum: <b>7</b> poin</p><p>4. Jika tidak terdeteksi bahwa pengguna menggunakan gambar palsu, tingkatkan <b>1 </b>Poin</p><p>5. Poin kredit di bawah <b>50</b> poin akan dibatasi penarikannya</p><p>6 . Poin kredit di bawah <b>30</b> b>Jumlah tap video dikurangi setengahnya</p><p>7. Poin kredit yang kurang dari atau sama dengan <b>0</b> poin akan diblokir< /p>",
    "kredit saya",
    "Tidak ada riwayat kredit saat ini"
  ],
  appDown: [
    "Download Aplikasi",
    "Pindai kode QR untuk mengunduh APLIKASI",
    "Simpan kode QR",
    "Simpan kode QR berhasil",
    "Gagal menyimpan kode QR, silakan coba beberapa kali atau simpan tangkapan layar",
    "salinan",
    "Unduh Android",
    "Unduhan iOS",
    "Jika versi iOS tidak dapat diunduh secara normal, silakan hapus instalan versi asli dan unduh dan instal lagi. Tidak menghapus instalan akan memengaruhi penggunaan"
  ],
  dialog: [
    "Informasi",
    "Ok",
    "Menyerahkan...",
    "Salin berhasil",
    "Versi sistem IOS rendah dan tidak didukung",
    "Mendaftar...",
    "Memuat...",
    "Belum dibuka, jadi pantau terus",
    "Simpan gambar berhasil",
    "Gagal menyimpan gambar<br>Jika tidak berhasil, silakan coba beberapa kali atau ambil screenshot untuk menyimpan",
    "Browser tidak mendukung, silakan ambil tangkapan layar",
    "Investasi sedang berlangsung",
    "Saat ini tidak ada paket pembayaran"
  ],
  lineList: [
    "Pemilihan jalur",
    "baris saat ini",
    "garis"
  ],
  serviceCenter: [
    "Pelayanan pelanggan",
    "Hai, layanan pelanggan eksklusif",
    "Senang melayani Anda",
    "swalayan",
    "layanan daring",
    "Layanan Pelanggan Isi Ulang",
    "Layanan Pelanggan Jalur",
    "Menghubung",
    "Petunjuk Bantuan",
    "Pemberitahuan Situs"
  ],
  theme: {
    title: "Ganti tema",
    black:"Tema hitam",
    white: "Tema putih",
    green: "Tema Hijau Tua"
  },
  Finance: [
    ["Dividen Harian", "Ekuitas Hadiah", "Opsi Hadiah", "Subsidi Tambahan", "Waktu"],
    "Beli sekarang",
    "Rincian Keuangan",
    "Harga Pesanan",
    ["Persen", "Hari"],
    "Pesan sekarang",
    ["Saldo Rekening", "Harga Satuan Proyek", "Dividen Harian", "Periode Proyek", "Hari", "Jumlah Pembelian", "Pembelian Maksimum", "Estimasi Penghasilan"],
    "Kirimkan",
    "Keuangan Saya",
    ["Minat", "Akhir", "Rincian"],
    ["Apakah Anda yakin akan menarik bunga, bunga akan dihitung ulang setelah penarikan", "Apakah Anda yakin akan mengakhiri pengelolaan keuangan ini"],
    "Detail pesanan",
    ["Jumlah Total", "Status Pesanan", "Tanggal Pembelian"]
  ],
  Video: [
    ["Pengunjung", "Upgrade dapat menikmati lebih banyak manfaat"],
    "Tingkatkan Segera",
    ["Pendapatan hari ini", "Setiap pesanan", "Untuk Penarikan"],
    ["Jumlah video yang ditonton hari ini", "Jumlah video yang tersisa"],
    "mulai menonton",
    "Masuk untuk menonton",
    "lihat dalam layar penuh",
    "penutupan",
    ["Merekomendasikan Anda untuk mengunduh", "Unduhan gratis"],
    "pengguna online",
    "Selesai sekali klik",
    "Tolong ikat nomor telepon Anda terlebih dahulu",
    "Silakan ikat alamat e-mail Anda terlebih dahulu"
  ],
  Disclaimer: [
    ["Saya telah membaca dan setuju", " Disclaimer"],
    ["Perjanjian Login", "Tidak Setuju", "Setuju"]
  ],
  Withdraw: [
    "Saldo yang tersedia {money}, silakan pilih akun penarikan",
    "Rekening Penarikan",
    "Silakan pilih akun penarikan",
    "Jumlah penarikan",
    "Silakan masukkan jumlah penarikan",
    "Alamat dompet",
    "Silakan masukkan alamat dompet",
    "Kata Sandi Dana",
    "Silakan masukkan kata sandi dana",
    "Tarik sekarang",
    "Nilai tukar: {price}÷{rate}=<b>{money}</b>USDT,(1USDT={currency}{rate})",
    "Pilih akun penarikan",
    ["Tambahkan rekening bank", "Ikat dompet USDT"],
    "Kredit sebenarnya",
    "Nomor telepon",
    "Silakan masukkan nomor telepon",
    "Surat",
    "silahkan masukan e-mail anda",
    "UPI",
    "Silahkan masuk UPI",
    "Penarikan USDT-TRC20 hanya mendukung penggunaan TRUST wallet",
    "Unduh TRUST Wallet"
  ],
  Partner: [
    "Tingkat Penggalangan Dana",
    "Penggalangan Dana",
    ["Memulai crowdfunding","Berpartisipasi dalam crowdfunding","Crowfunding saya"],
    ["Level crowdfunding", "Silakan pilih level crowdfunding"],
    ["Salinan crowdfunding", "Silakan pilih salinan crowdfunding"],
    ["Jumlah salinan yang dibeli", "Silakan masukkan jumlah salinan yang dibeli"],
    "Jumlah per saham",
    "Crowdfunding sekarang",
    ["Sedang berlangsung", "Selesai"],
    ["Inisiator","Tingkat Crowdfunding","Crowdfunding Salinan","Jumlah per Salinan","Dibeli","Salinan","Tambahan","Keuntungan","Partisipasi","Tanggal Crowdfunding"],
    "Aturan Penggalangan Dana",
    ["Nama crowdfunding","Silakan masukkan nama crowdfunding"]
  ],
  Share: [
    "Bonus Harian",
    ["Daftar Tugas", "Pengguna yang curang dan mendaftar akan diblokir", "Pergi untuk berbagi"],
    ["Langkah tugas","Unggah {num} kali per hari"],
    ["Gambar penarikan ke akun", "Gambar penarikan berhasil dibagikan ke obrolan grup", "Pengguna yang mengirimkan konten spam akan diblokir", "Setelah persetujuan, hadiah akan diberikan ke akun Anda "],
    ["Silahkan unggah screenshot", "Silakan masukkan alamat tautan {name} Anda", "Contoh gambar"],
    "Kirimkan",
    "Share",
    "Share penghasilan harian",
    "Petunjuk Panduan",
    "Bagikan salinan",
    "Salin Salin",
    "Kirim screenshot dan link",
    "Membatalkan",
    "klaim bonus ",
    "bonus"
  ],
  Community: [
    "dinamis",
    ["Terbaru", "Penarikan", "Beli", "Komisi", "Pendapatan"],
    ["harga","pendapatan per tampilan","video per hari"],
    "Aku juga ingin meningkatkan"
  ],
  Register: [
    "Silakan mengisi alamat e-mail anda",
    ["Silakan mengisi kode verifikasi e-mail", "Dapatkan kode e-mail", "Kode verifikasi e-mail"]
  ],
  UserInfo: [
    ["E-mail", "Klik untuk mengikat"],
    ["Ikat ponsel", "Ikat E-mail"],
    ["Nomor ponsel", "Silakan masukkan nomor ponsel"],
    ["E-mail", "Silakan masukkan e-mail"],
    "Silakan mengikat nomor ponsel Anda sebelum menarik",
    "Silakan mengikat alamat e-mail Anda sebelum menarik",
    ["Otentikasi Telegram", "Tutorial Otentikasi"]
  ],
  Bet: [
    "Jarak {no} periode pengundian lotere",
    "Menunggu undian",
    "Saldo rekening",
    "Mengharapkan",
    "Masalah",
    "Konten taruhan",
    "Catatan",
    "jumlah",
    "negara",
    "tidak ada catatan",
    "menyimpan",
    "waktu",
    "Masalah",
    "Nomor kemenangan",
    "jumlah",
    "Aku ingin bertaruh",
    "Selamat <em id='win_name'>{name}</em> karena telah bertaruh dalam <i id='win_lottery'>{lottery}</i> dan memenangkan <em id='win_money'>{currency}{price}</em>",
    "Taruhan<br>Saya",
    "kecenderungan",
    "bermain",
    "Cara bermain",
    "Kamar penghubung...",
    "Menunggu undian",
    "tidak menang",
    "Dibeli dengan {price}",
    "dihapus",
    "Dibatalkan",
    "berhenti",
    "jalan di air",
    "Kirim gagal, klik pesan untuk mengirim ulang",
    "Ruang taruhan tidak ada",
    "Apakah harus menelepon",
    "panggilan",
    "Browser Anda tidak mendukung protokol WebSocket",
    "Komunikasi obrolan gagal, mencoba menyambung kembali",
    "Tips yang baik",
    "Hapus layar dalam hitungan detik",
    "Browser Anda tidak mendukung",
    "Jenis Taruhan",
    "Anda belum login, silahkan login terlebih dahulu",
    "Hanya bisa mengirim gambar",
    "Saldo akun tidak cukup {balance}, Anda tidak dapat memasuki ruangan ini, silakan isi ulang",
    "kecenderungan",
    "situs resmi",
    "laba",
    ["taruhan", "pemenang", "rabat", "keuntungan"],
    ["hari ini","kemarin","minggu ini","bulan ini","total"]
  ],
  BetView: [
    "Odds Maks",
    "bonus",
    "Jumlah Cepat",
    "Catatan",
    "Masukan jumlah",
    "Membatalkan",
    "mengejar angka",
    "Bertaruh sekarang",
    "Memuat...",
    "Konten taruhan",
    "kemungkinan",
    "Silakan masukkan jumlah taruhan",
    "Masalah saat ini tidak terbuka",
    "Menunggu undian, tidak bisa bertaruh",
    "Masalah ini telah ditutup, silakan bertaruh pada edisi berikutnya",
    "Silakan pilih konten taruhan",
    "Tindak lanjut satu klik",
    "Masalah",
    "Mengharapkan",
    "bermain",
    "Konten taruhan",
    "Jumlah Taruhan",
    "Dokumenter",
    "Hanya tersedia untuk pengguna VIP"
  ],
  Coupon: [
    "Voucher",
    ["akan digunakan", "digunakan", "kedaluwarsa"],
    ["Voucher", "Berlaku sampai", "Nilai"],
    "transfer",
    ["Pilih semua", "Silakan masukkan nama pengguna untuk transfer", "Konfirmasi", "Batal"]
  ],
  Trend: [
    "kecenderungan",
    ["30 masalah", "50 masalah", "100 masalah"],
    ["Tren angka tunggal", "Tren beberapa angka", "Tren ukuran", "Tren tunggal dan ganda", "Nilai jumlah|pola"],
    ["ratusan", "puluhan", "satuan", "tiga yard", "dua pertama", "dua terakhir", "tiga yard dan nilai"],
    ['Ratusan sepuluh,3', 'ratusan,2', 'puluhan,2', 'satuan,2'],
    ['Seratus sepuluh,3', 'jumlah nilai', 'pola,2'],
    ["ukuran"],
    ["ganda", "tunggal"],
    ["besar", "kecil", "dan", "ganda", "tunggal"],
    "Mengharapkan",
    ["Jumlah Periode", "Jumlah Kejadian", "Keluar Kontinu Maksimum", "Penghilangan Maksimum", "Penghilangan Rata-Rata"]
  ],
  BlindBox: [
    "Catatan Hadiah"
  ],
  Activity: [
    "Aktivitas",
    ["Semua", "Agen", "Anggota", "Kerjasama Strategis", "Berakhir"],
    "cek detailnya"
  ],
  Invest: [
    "item keuangan",
    "jaminan",
    "Tarif Harian",
    "Tingkat Bunga Disetahunkan",
    "hari",
    "Jangka Waktu Investasi",
    "Total Suku Bunga",
    "Jumlah Awal",
    "Jumlah total saham yang diterbitkan: {num}",
    "Ukuran Proyek: {besaran_proyek} {skala_proyek}",
    "Investasikan Sekarang",
    "Habis terjual",
    "Kemajuan_Proyek",
    "Saldo Akun yang Tersedia",
    "Jumlah yang tersedia untuk diinvestasikan dalam proyek",
    "Nama Proyek",
    "Jumlah yang Diinvestasikan",
    "Waktu Penyelesaian Bunga",
    "Jumlah investasi",
    "Investasi Minimum",
    "Inkremental",
    "Penghasilan yang Tersedia",
    "Kata sandi pendanaan",
    "Silakan masukkan kata sandi pendanaan Anda, defaultnya adalah kata sandi login Anda",
    "Investasikan Sekarang",
    "Harap verifikasi nama asli Anda terlebih dahulu",
    "Anda belum menetapkan kata sandi untuk dana Anda, silakan lakukan itu"
  ],
  InvestOrder: [
    "saham",
    ["Dividen Per Saham", "Periode Proyek", "Hari", "Jumlah Investasi"],
    ["Nama Proyek", "Jumlah Investasi", "Status", "Tindakan"],
    ["Transfer Keluar", "Rincian"]
  ],
  InvestDetail: [
    "Rincian investasi",
    "Jumlah investasi",
    "Manfaat yang diharapkan",
    "Waktu Investasi",
    "Kedewasaan",
    "Metode Manfaat",
    "Nomor Masalah",
    "Piutang Pokok",
    "Piutang Bunga",
    "Jumlah Total Piutang",
    "Waktu Pembayaran",
    "Dibayar",
    "Status",
    "Periode {no}",
    "Kontrak",
    "Rincian Kontrak"
  ],
}